import React from 'react';
import { FaFacebookF, Twitter, FaLinkedinIn, FaYoutube, FaPhone, FaPhoneAlt, FaMailBulk, FaVoicemail, FaEnvelope, FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { IoPhonePortraitOutline } from 'react-icons/io5'; // Clean smartphone/phone icon
import { MdOutlineMail } from 'react-icons/md'; // Clean envelope icon
import "./topheader.css"; 

function Topheader() {
  return (
    <div className="fz-top-header-bar">
      {/* Left side: Social Icons */}
      <div className="fz-social-links-box">
        <a href="https://www.facebook.com/share/1G4PfTp6Bv/?mibextid=wwXIfr"  target='_blank' rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
        <a href="https://wa.me/916380866249"aria-label="Twitter"target='_blank' rel="noopener noreferrer"><FaWhatsapp /></a>
        <a href="https://www.linkedin.com/company/fazo-academy/" target='_blank' rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
        <a href="https://www.instagram.com/fazo_academy?utm_source=qr&igsh=MWR3djJ4cHJsejlnOA=="  target='_blank' rel="noopener noreferrer"aria-label="YouTube"><FaInstagram /></a>
      </div>

      {/* Right side: Contact Details */}
      <div className="fz-contact-info-box">
        <a href="tel:+916380886249" className="fz-contact-item-link">
          <FaPhoneAlt className="fz-contact-icon" />
          <span>+91 6380886249</span>
        </a>
        <a href="tel:04435670376" className="fz-contact-item-link">
          <FaPhoneAlt className="fz-contact-icon" />
          <span>044 35670376</span>
        </a>
        <a href="mailto:info@fazoacademy.com" className="fz-contact-item-link">
          <FaEnvelope className="fz-contact-icon" />
          <span>info@fazoacademy.com</span>
        </a>
      </div>
    </div>
  );
}

export default Topheader;